export const GET_COMPANY_CONTACTS = Symbol('GET_COMPANY_CONTACTS');
export const GET_COMPANY_CONTACTS_REQUEST = Symbol('GET_COMPANY_CONTACTS_REQUEST');
export const GET_COMPANY_CONTACTS_SUCCESS = Symbol('GET_COMPANY_CONTACTS_SUCCESS');
export const GET_COMPANY_CONTACTS_ERROR = Symbol('GET_COMPANY_CONTACTS_ERROR');

